export default __webpack_public_path__ + "static/media/NIAS0540.34I-40172_-23840_0.c3a1a3f4.jpg";